import {useContext, useEffect, useRef, useState} from 'react';
import {TopicRoutingEndpointResponseSuccess} from '../../../generated/types';
import {ConfigContext} from '../../Providers/ConfigProvider';
import {useApi} from '../../Providers/ApiProvider/ApiProvider';

export const useTopics = () => {
  const {fetchTopics} = useApi();

  const ref = useRef<boolean>(false);
  const [topics, setTopics] = useState<
    TopicRoutingEndpointResponseSuccess['topics'] | null
  >(null);

  const {entrypoint} = useContext(ConfigContext);

  useEffect(() => {
    if (!topics && !ref.current) {
      ref.current = true;

      if (!entrypoint) {
        setTopics([]);
        return;
      }

      fetchTopics(entrypoint).then((result) => {
        if (result.type === 'success') {
          setTopics(result.topics);
        } else {
          setTopics([]);
        }
      });
    }
  }, [entrypoint, topics, fetchTopics]);

  return {topics};
};
